import SingleLineTask from "@/components/SingleLineTask/singleLineTask.component";
import SingleLineTaskMobile from "@/components/SingleLineTask/singleLineTaskMobile.component";
import { useMediaQuery } from "@/hooks/AppContext/mediaQuery";
import useChangeStatus from "@/hooks/SingleLineTask/useChangeStatus.hook";
import { Button } from "@/shadcn/components/ui/button";
import { BasicTask } from "@/types";
import { AnimatePresence, motion } from "framer-motion";
import React, { useState } from "react";

type ToggleTasksProps = {
  type: "Overdue" | "Due Today" | "Due Later" | "No Due Date";
  tasks: BasicTask[];
  showRowsInitial: boolean;
  selectedTaskIds?: Set<number>;
  onToggleTaskSelection?: (taskID: number, selected: boolean) => void;
  inlineEditingDisabled?: boolean;
  bulkEditVersion?: number;
};

const ToggleTasks: React.FC<ToggleTasksProps> = ({
  type,
  tasks,
  showRowsInitial,
  selectedTaskIds,
  onToggleTaskSelection,
  inlineEditingDisabled = false,
  bulkEditVersion = 0,
}) => {
  const [showRows, setShowRows] = useState<boolean>(showRowsInitial);

  // #region Task Handling
  const { completeTask } = useChangeStatus("UserTasks");
  // #endregion Task Handling

  const isNotSmall = useMediaQuery("sm");

  return (
    <>
      <Button
        variant="ghost"
        className="px-1 py-1 my-1 h-auto w-full justify-start"
        onClick={() => {
          setShowRows(!showRows);
        }}
      >
        {type} {type === "Overdue" && "Tasks"}{" "}
        {tasks && tasks.length > 0 ? " : " + tasks.length : ""}
      </Button>
      {!showRows && <hr />}
      <AnimatePresence>
        {showRows && (
          <motion.div
            initial={{ opacity: 0, y: -25 }}
            animate={{ opacity: 1, y: 0 }}
          >
            {tasks.length === 0 ? (
              <div className="p-2">
                {type === "Overdue"
                  ? `No ${type} Tasks`
                  : type === "Due Today"
                    ? `No Tasks ${type}`
                    : type === "Due Later"
                      ? `No Tasks ${type}`
                      : type === "No Due Date"
                        ? `No Tasks`
                        : `Unknown Task Type`}
              </div>
            ) : (
              tasks.map((task) => (
                <div key={task.id} className="mb-3">
                  {isNotSmall ? (
                    <SingleLineTask
                      task={task}
                      completeTask={completeTask}
                      taskType={type}
                      inlineEditingDisabled={inlineEditingDisabled}
                      bulkEditVersion={bulkEditVersion}
                      isSelected={selectedTaskIds?.has(task.id) ?? false}
                      onSelectChange={
                        onToggleTaskSelection
                          ? (selected) =>
                              onToggleTaskSelection(task.id, selected)
                          : undefined
                      }
                    />
                  ) : (
                    <SingleLineTaskMobile
                      task={task}
                      completeTask={completeTask}
                      taskType={type}
                      inlineEditingDisabled={inlineEditingDisabled}
                      isSelected={selectedTaskIds?.has(task.id) ?? false}
                      onSelectChange={
                        onToggleTaskSelection
                          ? (selected) =>
                              onToggleTaskSelection(task.id, selected)
                          : undefined
                      }
                    />
                  )}
                </div>
              ))
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default ToggleTasks;
